/** @module Specification/SizeMap/ViewSizeMapController */
define([
	"dojo/_base/declare",
	"csi/action/PopupController",
	"./_ControllerMixin"
], function(declare,PopupController,_ControllerMixin) {

	return declare([PopupController,_ControllerMixin], {
		/**
		 * @override
		 * Read only in popup view
		 */
		onFormData: function(fd) {
			fd.m_bEditable = false;
			fd.m_bAllowSelections = false;
		}
	});
});